window.addEventListener('DOMContentLoaded',function(){

    document.addEventListener("cart:update", event => {
        new Shopify.CountryProvinceSelector("address_country", "address_province", {hideElement: "address_province_container"});
        Shopify.Cart.ShippingCalculator.show()

        initForm()
        document.querySelector("#cartShipping").classList.remove("active")
    })

    function initForm(){

        const inputState = document.querySelector("#cartShipping #address_province")
        const inputZip = document.querySelector("#cartShipping #address_zip")


        let location = localStorage.getItem('UserLocation')
        let UserZip = localStorage.getItem('UserZip')

        if(!UserZip) return
        let state
        if (location?.includes("Portland")){
            state = "Oregon"
        }else if(location?.includes("Salt Lake City")){
            state = "Utah"
        }else{
            state = "Washington"
        }
        inputState.setAttribute("data-default", state)
        inputZip.value = UserZip


        document.querySelector(".get-rates")?.addEventListener("click", (event)=> {
            if(event.currentTarget.hasAttribute("href")){
                window.location.href = event.getAttribute("href")
            }
        })

        const responseWrapper = document.querySelector("#wrapper-response")
        if(!responseWrapper) return;
        responseWrapper.innerHTML = ""
    }
    initForm()



    function shippingSupportHandler(shippingState){
        const wrapper = document.querySelector("#shipping-calculator")
        if(!wrapper) return
        wrapper.classList.toggle("contact-state", !shippingState)
    }
});
